
<template>
  <div class="dashboard-stat">
    <div class="dashboard-stat--left">
     <div v-if="showIcon" :class="['icon', icon ]">
       <md-icon>{{ icons[icon] || icons.count }}</md-icon>
     </div>
     <div>
       <p>{{ label }}</p>
       <md-tooltip v-if="data.value" md-direction="top">{{ data.value || "-" }}</md-tooltip>
       <h3>
         <span v-if="loading">-</span>
         <span v-else class="value">{{data.value ? data.formatted_value : value }}</span>
       </h3>
     </div>
    </div>
    <div v-if="loading">
      <md-progress-spinner
        class="md-success"
        :md-stroke="3"
        :md-diameter="20"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardStat",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'currency'
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: "-"
    },
    data: {
      type: Object,
      default: () => {
        return { value: null, formatted_value: null }
      }
    }
  },
  data() {
    return {
      icons: {
        count: 'published_with_changes',
        currency: '₦'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-stat {
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #E9E9EB;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  &--left {
    display: flex;
  }

  .icon {
    height: 40px;
    width: 40px;
    background-color: #4caf50;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;

    &.count {
      background-color: #FF9D00;
    }

    &.currency  i {
      margin-top: 5px;
    }

    i {
      color: #fff;
      font-size: 22px !important;
    }
  }

  p {
    margin: 0 0 3px;
    color: #888888;
    font-weight: 500;
    font-size: 15px;
  }

  h3 {
    font-weight: 700;
    margin: 0;
    line-height: 1;
    font-size: 28px;
    font-family: "Figtree", sans-serif;

    .value {
      -webkit-animation: fadeIn 500ms linear 0s;
      -moz-animation: fadeIn 500ms linear 0s;
      animation: fadeIn 500ms 0s;
      -webkit-animation-fill-mode: forwards;
      -moz-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }

  .md-progress-spinner.md-theme-default :deep(.md-progress-spinner-circle) {
    stroke: #ff6d00 !important;
  }
}
</style>
